import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionButton,
  AccordionIcon, AccordionItem,
  AccordionPanel,
  Box, Flex,
  Grid,
  GridItem,
  Heading,
  Text
} from "@chakra-ui/react";
import * as React from "react";
import { translateSubElementString } from "../../../../../../utils";
import {
  SCOPE_3_CATEGORIES_KEYS
} from "../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeThree/const";
import { dataTypeColours } from "./helpers";
import { NumberField } from "../../../../../../components/NumberField";
import { Fragment } from "react";
import { IconTitle } from "../../../../../../components/IconTitle";
import ManualEmissionsList from "../../shared/ManualEmissionsList";

const ORDERED_CATEGORIES = [
  SCOPE_3_CATEGORIES_KEYS.categoryOne,
  SCOPE_3_CATEGORIES_KEYS.categoryTwo,
  SCOPE_3_CATEGORIES_KEYS.categoryThree,
  SCOPE_3_CATEGORIES_KEYS.categoryFour,
  SCOPE_3_CATEGORIES_KEYS.categoryFive,
  SCOPE_3_CATEGORIES_KEYS.categorySix,
  SCOPE_3_CATEGORIES_KEYS.categorySeven,
  SCOPE_3_CATEGORIES_KEYS.categoryEight,
  SCOPE_3_CATEGORIES_KEYS.categoryNine,
  SCOPE_3_CATEGORIES_KEYS.categoryTen,
  SCOPE_3_CATEGORIES_KEYS.categoryEleven,
  SCOPE_3_CATEGORIES_KEYS.categoryTwelve,
  SCOPE_3_CATEGORIES_KEYS.categoryThirteen,
  SCOPE_3_CATEGORIES_KEYS.categoryFourteen,
  SCOPE_3_CATEGORIES_KEYS.categoryFifteen
];

function DimensionScopeThreeSection({ data, manualEmissions, hasOtherData }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThreeByDimension"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const manualRows = manualEmissions ?? [];
  const hasManualRows = manualRows.length > 0;
  const hasActivity = data && data.scopeThreeTotalCo2Emissions > 0;

  if (!hasActivity && !hasManualRows && !hasOtherData) return null;

  return (
      <Box border="1px solid" borderColor="gray.200" borderRadius="md" padding={4} marginBottom={5}>
        <Heading size="md" marginBlock="1">
          {t("sectionTitle")}
        </Heading>
        {hasActivity ?
          <>
            <Accordion defaultIndex={[0]} allowMultiple margin="20px 0">
              <AccordionItem>
                {
                  ({ isExpanded }) => {
                    return <>
                      <h2>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            <Heading color="esg_gray.200" size="xs">
                              {t("accordionItemTitle")}
                            </Heading>
                          </Box>
                          <Text fontSize={"sm"} mr={2}>
                            {isExpanded ? globalTranslation("buttons.collapse") : globalTranslation("buttons.expand")}
                          </Text>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pt={2} pb={5} overflow="auto">
                        <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                          <GridItem></GridItem><GridItem></GridItem>
                          <GridItem>
                            <Heading marginBlock="1" align="right" size="sm">
                              {translateSubElementString("reportsPage.totalEmissions")}
                            </Heading>
                          </GridItem>

                          {ORDERED_CATEGORIES
                            .filter(catKey => data[`${catKey}TotalCo2Emissions`] > 0)
                            .map((catKey, catIndex) => {
                              return <Fragment key={catKey}>
                                <GridItem>
                                  <Flex gap="3" inlineSize="400px" alignItems={"center"}>
                                    <Box
                                      width={3}
                                      height={3}
                                      backgroundColor={dataTypeColours["scopeThreeCategory"]}
                                      borderRadius={"50%"}
                                      display={"inline-block"}
                                    />
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      fontSize="sm"
                                      whiteSpace="break-spaces">
                                      <Text>
                                        <b>
                                          {globalTranslation("category")} {ORDERED_CATEGORIES.indexOf(catKey) + 1}
                                          : {globalTranslation(`supplierQuestionnaire.scopeThree.categories.${catKey}.name`)}
                                        </b>
                                      </Text>
                                    </Box>
                                  </Flex>
                                </GridItem>
                                <GridItem>
                                </GridItem>
                                <GridItem>
                                  <NumberField value={data[`${catKey}TotalCo2Emissions`]} />
                                </GridItem>
                              </Fragment>;
                            })
                          }
                        </Grid>
                      </AccordionPanel>
                    </>;
                  }
                }
              </AccordionItem>
            </Accordion>
            <Grid templateColumns="repeat(3, 1fr)" gap={2} overflow="auto" paddingInlineEnd={4}>
              <GridItem>
                <IconTitle
                  icon={undefined}
                  title={translateSubElementString("reportsPage.scopeThreeByDimension.total")}
                  subTitle={` (${globalTranslation(`measures.tonnes`)})`}
                />
              </GridItem>
              <GridItem></GridItem>
              <GridItem>
                <NumberField fontWeight="bold" value={data.scopeThreeTotalCo2Emissions} />
              </GridItem>
            </Grid>
          </>
          :
          !hasManualRows && <Text fontSize="lg" fontWeight="bold">
            {globalTranslation("reportsPage.scope1&2.dimension.noFilteredData")}
          </Text>
        }
        <ManualEmissionsList items={manualRows} />
      </Box>
  );
}

export default DimensionScopeThreeSection;